export default __webpack_public_path__ + "static/media/project-four-img.3e8f7f44.svg";